import React from "react";
import ResourceViewer from "./ResourceViewer";
import ManualPDF from "../../public/Files/pdf/Manual.pdf";

export default function Manual() {
  return (
    <ResourceViewer
      title="LIMS User Manual"
      description="Learn how to use the LIMS platform and explore its crop monitoring features."
      type="pdf"
      file={ManualPDF}
    />
  );
}